
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    text: {
      type: String,
      default: "没有找到相关内容"
    }
  }
});
